<template>
  <section class="ut-m-0 ut-p-4">
    <div class="ut-card-base ut-p-8 ut-h-full">
      <div class="ut-flex ut-justify-start">
        <h3 class="ut-uppercase ut-mx-0">{{ title }}</h3>
        <span v-if="infoText"
              class="ut-rounded-full ut-w-5 ut-h-5 ut-border ut-mx-2 ut-text-center ut-cursor-pointer"
              v-tooltip="{content: infoText, classes: ['info'], trigger: 'hover click'}">i</span>
      </div>
      <div class="ut-flex ut-my-8 ut-justify-between">
        <p class="ut-mx-0 stat">{{ stat | placeholderWhenNoData }}</p>
        <figure class="ut-rounded-full ut-border ut-border-solid">
        <svg-icon v-if="iconName"
                  :icon="iconName"
                  :size="22"
                  :addClass="''"></svg-icon>
        </figure>
      </div>
      <hr />
      <slot></slot>
    </div>
  </section>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';

export default {
  name: 'PerformancePremierStatsCard',
  components: {
    SvgIcon,
  },
  props: {
    iconName: {
      required: false,
      type: String,
      default: null,
    },
    title: {
      required: false,
      type: String,
      default: null,
    },
    stat: {
      required: false,
      type: Number,
      default: null,
    },
    infoText: {
      required: false,
      type: String,
      default: null,
    },
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
  h3 {
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 1px;
    line-height: 21px;
  }

  p.stat {
    color: #233A3A;
    font-size: 36px;
    font-weight: 600;
    letter-spacing: -0.51px;
    line-height: 36px;
  }

  hr {
    @apply ut--mx-8 mb-8;
    border: 1px solid #DDDDDD;
  }

  figure {
    @apply ut-flex ut-items-center ut-justify-center;
    border-color: #99E0AD;
    color: #00AB64;
    height: 49px;
    width: 49px;
  }

  .tooltip {
      max-width: 250px;
  }
</style>
